// extracted by mini-css-extract-plugin
export default {"root":"LeaseType_root__DEsd4","info-box":"LeaseType_info-box__5sEI0","footer":"LeaseType_footer__9IPTw"};